<template>
  <div class="wrapper">
    <div>
    <CRow class="mt-3">
      <div>  
      </div>
      <CCol sm="12">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <Datatable 
                            :items="items" 
                            :fields="fields" 
                            :meta="meta" 
                            @per_page="handlePerPage" 
                            @pagination="handlePagination" 
                            @search="handleSearch" 
                            @sort="handleSort"
                            @is_active="handleIsActive"
                            @assign_user="handleAssign_User"
                            @assign_permission="handleAssign_Permission"
                            @edit="handleEdit"
                            @destroy="handleDestroy"
                        />
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12 ">
                <div class="card">
                    <div class="card-body">
                      <h3>Assigned Teacher</h3>
                      <hr>
                      <table class="table ">
                        <thead>
                          <tr>
                            <th >
                            {{ 'Firstname' }}
                            </th>
                            <th class="d-flex justify-content-around" >
                            {{ 'Action' }}
                            </th>
                          </tr>
                        </thead>
                      <tbody>
                        <tr v-for="i in teachers" :key="i.id"  >
                          <td >{{ i.firstname + " " + i.lastname}}</td>
                          <td class="d-flex justify-content-around">
                            <CButton class="ml-2 button-detail" color="danger" size="sm" @click="deleteteacher(i.id)">Delete Teacher</CButton>
                          </td>
                        </tr>
                      </tbody>
                      </table>
                    </div>
                </div>
            </div>
        </div>
      </CCol>
    </CRow>
      <alertmodal></alertmodal>
    </div>
  </div>
</template>

<script>
import Datatable from '@/components/datatables_class_teacher.vue'
import axios from 'axios'

import classschedule from '@/services/class_schedule'
import roles from '@/services/roles'

import alertmodal from '@/views/alert/modal.vue';
import EventBus from '@/eventBus';

const token = localStorage.getItem('token');

export default {
  name: 'role',
  components: { alertmodal, Datatable },
  data(){
    return{
      form:{
        idmember:'',
      },
      updateSubmit: false,
      largeModal:false,
      datas:[], 

      fields: [
          {key: 'firstname', sortable: false, },
          {key: 'action', label: 'Action', sortable: false},
      ],
      items: [],
      teachers: [],
      listteacher:[],
      meta: [],
      current_page: 1,
      per_page: 5,
      search: '',
      sortBy: 'name',
      sortByDesc: false,
      //is_active: 1,
    }
  },

  created() {
      //this.loadData()
  },
  mounted (){
     this.loadData()

    EventBus.$on('TABLE_UPDATE', (data) => {
      if(data){
          this.loadData();
      }
    });

   },
   
  methods: {
    openModal: function () {
      var params = {title: 'Add New Role', mode:'create'}
      EventBus.$emit('OPEN_MODAL_ROLE', params)
    },
    

    deleteteacher(id){
      if(confirm("Do you really want to delete?")){
        this.form.idmember = id
        classschedule.deleteClassTeacher(this.form)
        .then(res => {
          EventBus.$emit('TABLE_UPDATE', true)
          var params = {title: 'Success', mode:'success', data:res.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      }  
    },

    assignteacher(id){
      if(confirm("Do you really want to assign?")){
        this.form.idmember = id
        classschedule.assignClassTeacher(this.form)
        .then(res => {
          EventBus.$emit('TABLE_UPDATE', true)
          var params = {title: 'Success', mode:'success', data:res.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      }  
    },

    loadData() {
      let current_page = this.search == '' ? this.current_page:1
      var params = {
        //headers: { "Authorization" : `Bearer ${token}` },
        page: this.current_page,
        per_page: this.per_page,
        search: this.search,
        sortby: this.sortBy,
        sortbydesc: this.sortByDesc ? 'DESC':'ASC',
        is_active: this.is_active,
      }

      classschedule.getClassTeacher(params)
      .then(res => {
          let getData = res.data
          this.items = getData.data
          this.teachers = res.teacher
          //this.is_active = res.is_active
          this.meta = {
              total: getData.total,
              current_page: getData.current_page,
              per_page: getData.per_page,
              from: getData.from,
              to: getData.to,
              is_active: res.is_active
          }
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })
    },

    handlePerPage(val) {
        this.per_page = val 
        this.loadData() 
    },
    
    handlePagination(val) {
        this.current_page = val 
        this.loadData()
    },
    
    handleSearch(val) {
        this.search = val 
        this.current_page = 1 
        this.loadData() 
    },
  
    handleSort(val) {
        this.sortBy = val.sortBy
        this.sortByDesc = val.sortDesc
        this.loadData()
    },
    
    handleIsActive(val) {
        this.is_active = val 
        this.loadData() 
    },

////HANDLE FUNCTION BUTTON ACTION////
    handleAssign_User(val) {
        //this.assignuser(val) 
    }, 
    handleEdit(val) {
        this.assignteacher(val) 
    },    
    handleAssign_Permission(val) {
        //this.assignpermission(val)       
    },
    handleDestroy(val) {
        this.delete(val)       
    },

  }
}
</script>